const DISMISS_QUERY_PREFIXES = [' ', '.'];
export function isSuggestionQueryDismissed(state, range, triggerChar) {
    const text = state.doc.textBetween(range.from, range.to);
    const query = text.startsWith(triggerChar) ? text.slice(triggerChar.length) : text;
    return DISMISS_QUERY_PREFIXES.some((prefix) => query.startsWith(prefix));
}
